import { useHistory } from 'react-router';
import { useCallback } from 'react';
import { useGlobalContext } from 'constants/context';

const useSearch = () => {
  const { push, location: { pathname } } = useHistory();

  const ifNotHomeGoToHome = useCallback((searchText, option) => {
    if (pathname !== '/search') push('/search');
    if (searchText === '' || option) push('/items');
  }, [pathname, push]);
  const { setContextState } = useGlobalContext();

  const setSearch = useCallback((searchValue) => { setContextState((state) => ({ ...state, searchValue, filters: [] })); }, [setContextState]);
  return { setSearch, ifNotHomeGoToHome };
};
export default useSearch;
